import React from "react";
import StudentController from "../api/StudentController";
import HistoricClassesAccordionView from "./HistoricClassesAccordionView";
import { Card, Table } from "react-bootstrap";

interface HistoricClassesViewProps
{
    data: Classes;
}

export default class HistoricClassesView extends React.Component<HistoricClassesViewProps>
{
    studentController: StudentController;

    constructor(props: any)
    {
        super(props);

        this.studentController = new StudentController();
    }

    async getClassData(termCode: string)
    {
        const data = await this.studentController.getClasses(termCode);

        this.setState({
            isloading: false,
            subjectData: data.classes[0]
        });
    }

    render(): React.ReactNode 
    {
        return (<React.Fragment>
            {
                (this.props.data.classes && this.props.data.classes.length > 0)
                ?
                this.props.data.classes.map((cls: Class, i: number) => 
                {
                    return <HistoricClassesAccordionView key={i} data={cls} />;
                })
                :
                <div id='error'>
                    <Card className={"border mb-3"}>
                        <Table responsive className="list">
                            <thead>
                                <tr>
                                    <th>SUBJECT</th>
                                    <th>SUBJECT TITLE</th>
                                    <th>ASSIGNMENTS</th>
                                    <th>STATUS</th>
                                    <th>INSTRUCTOR</th>
                                    <th>UNITS</th>
                                    <th>GRADE</th>
                                    <th>&nbsp;</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr className="text-center">
                                    <td colSpan={7}>
                                        <p className="error-text">No Classes data available</p>
                                    </td>
                                </tr>
                            </tbody>
                        </Table>
                    </Card>
                </div>
            }
        </React.Fragment>);
    }
}